// Shared auth-args shape for API clients. The SPA authenticates with a user-delegated MSAL bearer
// (acquired via useAuth().acquireApiToken) plus non-secret identity hints. On the corporate network the
// middleware also trusts these same-origin identity headers directly; off-corp the bearer is required.

export interface AuthArgs {
  authBearer: string;
  homeAccountId: string;
  username?: string | null;
  displayName?: string | null;
}

/** Builds the standard Authorization + identity-hint headers sent by every authenticated API client. */
export function authHeaders(args: AuthArgs, includeJsonContentType = true): Record<string, string> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${args.authBearer}`,
    'X-CMSP-User-HomeAccountId': args.homeAccountId,
  };
  if (includeJsonContentType) {
    headers['Content-Type'] = 'application/json';
  }
  if (args.username) {
    headers['X-CMSP-User-Username'] = args.username;
  }
  if (args.displayName) {
    headers['X-CMSP-User-DisplayName'] = args.displayName;
  }
  return headers;
}
